import { createSlice } from '@reduxjs/toolkit'
import { GetEvents } from '../api/EventsApi'

const initialState = {
    events:[],
    loading:false,
}

export const EventSlice = createSlice({
  name: 'EventSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
 
   
      builder.addCase(GetEvents.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(GetEvents.fulfilled , (state, action) => {
       
        state.events=action.payload?.data?.data; 
       
        state.loading = false;
      })
      builder.addCase(GetEvents.rejected, (state, action) => {
        state.loading = false;
      
      })
    
  },

})



export default EventSlice.reducer